import EnrollPatientDrawer from './EnrollPatientDrawer';

export default EnrollPatientDrawer;
